import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { PatientInteractionLocationImport } from 'app/core/models/patient-interaction-location-import.model';
import { PatientInteractionLocationImportsService } from 'app/core/services/patient-interaction-location-imports.service';
import { DownloadService } from 'app/core/services/download.service';
import { LimitOffsetPaging } from 'app/core/models/paged-results/limit-offset-paging.model';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';
import { DecimalPipe, TitleCasePipe, DatePipe } from '@angular/common';
import { PaginationHeaderComponent } from '../../../shared/components/pagination-header/pagination-header.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
    selector: 'app-capture-admin-import-patient-interaction-locations-history',
    templateUrl: './capture-admin-import-patient-interaction-locations-history.component.html',
    imports: [ImportNavComponent,
              PaginationHeaderComponent,
              FaIconComponent,
              NgbDropdown,
              NgbDropdownToggle,
              NgbDropdownMenu,
              PaginationComponent,
              MatProgressSpinner,
              DecimalPipe,
              TitleCasePipe,
              DatePipe,
              BlankValueDashPipe]
})
export class CaptureAdminImportPatientInteractionLocationsHistoryComponent implements OnInit, OnDestroy {
  private patientInteractionLocationImportsService = inject(PatientInteractionLocationImportsService);
  private downloadService = inject(DownloadService);

  loading = false;
  patientInteractionLocationImports: PatientInteractionLocationImport[] = [];
  nextCheckTimeout = null;
  paging: LimitOffsetPaging;

  ngOnInit() {
    this.paging = LimitOffsetPaging.empty;
    this.paging.currentPage = 1;
    this.loadImports(this.paging.currentPage);
  }

  ngOnDestroy() {
    clearTimeout(this.nextCheckTimeout);
  }

  onPageSizeChange(size: number) {
    this.paging.pageSize = size;
    this.loadImports(this.paging.currentPage);
  }

  onPageChange(page: number) {
    this.loadImports(page);
  }

  onCancelClick($event, patientInteractionLocationImport: PatientInteractionLocationImport) {
    $event.preventDefault();
    this.patientInteractionLocationImportsService.
      cancel(patientInteractionLocationImport.id).subscribe(invoiceImport => {
        const index = this.patientInteractionLocationImports.findIndex(imp => imp.id === invoiceImport.id);

        if (index > -1) {
          this.patientInteractionLocationImports[index] = invoiceImport;
          this.patientInteractionLocationImports = [...this.patientInteractionLocationImports];
        }
      });
  }

  onDownloadOriginalClick($event, patientInteractionLocationImport: PatientInteractionLocationImport) {
    $event.preventDefault();
    this.patientInteractionLocationImportsService.get(patientInteractionLocationImport.id).subscribe(invoiceImport => {
      const downloadUrl = invoiceImport.fileExpirableDownloadPath;
      this.downloadService.getDownloadUrl(downloadUrl).subscribe(expirableDownload => {
        this.downloadService.download(expirableDownload.url);
      });
    });
  }

  onDownloadSkippedClick($event, patientInteractionLocationImport: PatientInteractionLocationImport) {
    $event.preventDefault();
    this.patientInteractionLocationImportsService.get(patientInteractionLocationImport.id).subscribe(invoiceImport => {
      const downloadUrl = invoiceImport.skippedFileExpirableDownloadPath;
      this.downloadService.getDownloadUrl(downloadUrl).subscribe(expirableDownload => {
        this.downloadService.download(expirableDownload.url);
      });
    });
  }

  private loadImports(page, loading = true) {
    this.loading = loading;
    const paging = { page, pageSize: this.paging.pageSize };
    this.patientInteractionLocationImportsService.getList(paging).subscribe(result => {
      this.patientInteractionLocationImports = result.patientInteractionLocationImports;
      this.paging = result.meta.paging;
      this.loading = false;

      const anyActive: boolean = this.patientInteractionLocationImports.some(invoiceImport => invoiceImport.active);

      if (anyActive) {
        this.nextCheckTimeout = setTimeout(() => this.loadImports(this.paging.currentPage, false), 500);
      }
    });
  }
}
